import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import Candidate from "../../layouts/Candidate";
import axios from "../../services/axios";
import ReactLoading from "react-loading";
import useAxios from "../../hooks/useAxios";

function ValidateMobile() {
  const api = useAxios();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const walkInType = searchParams.get("walkInType" || "");
  const mobileNum = searchParams.get("mobile" || "");
  const emailId = searchParams.get("email" || "");
  const formName_ = searchParams.get("formname" || "");
  const sourceName = searchParams.get("source" || "");
  const referalCode = searchParams.get("refcode" || "");
  const consultancyName = searchParams.get("consultant_name" || "");
  const utm_medium = searchParams.get("utm_medium", "");
  const utm_campaign = searchParams.get("utm_campaign", "");
  const utm_term = searchParams.get("utm_term", "");

  // const utm_medium = searchParams.get("utm_medium", "");
  // const utm_campaign = searchParams.get("utm_campaign", "");
  // const utm_term = searchParams.get("utm_term", "");
  const client = searchParams.get("client", "");

  var decodedNum = atob(mobileNum);
  const formIds = useParams();

  const formId = formIds.id;
  const [number, setNumber] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [otp, setOtp] = useState("");
  const [otpCode, setOtpCode] = useState(true);
  const [otpErr, setOtpErr] = useState("");
  const [status, setStatus] = useState(false);
  const [numberError, setNumberError] = useState("");
  const [name, setName] = useState("");
  const [nameErr, setNameErr] = useState("");
  const [email, setEmail] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [requestCount, setRequestCount] = useState("");
  const [link, setLink] = useState("");
  const [numVerifiedErr, setNumVerifiedErr] = useState("");
  const [mobileId, setMobileId] = useState(false);
  const [countDown, setCountDown] = useState(true);
  const [resendStatus, setResendStatus] = useState(false);
  const [formStatus, setFormStatus] = useState(false);
  const [load, setLoad] = useState(false);
  const [formName, setFormName] = useState(formName_ || "");

  useEffect(() => {
    const LoadFormTemplate = async () => {
      try {
        const res = await api.get(`/formtemplate/${formId}`);
        setFormName(res.data?.name);
        console.log(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    LoadFormTemplate();
  }, []);

  useEffect(() => {
    if (mobileNum && emailId && referalCode) {
      sessionStorage.setItem("item_key", mobileNum);
      setNumber(mobileNum);
      setEmail(emailId);
    }
    validateSamparkRefData();
  }, [mobileNum, emailId]);

  const validateSamparkRefData = () => {
    if (referalCode && !client) {
      window.location.replace("/invalidUrl");
    } else if (!referalCode && client) {
      window.location.replace("/invalidUrl");
    } else if (referalCode === "" && client === "") {
      window.location.replace("/invalidUrl");
    }
  };

  const handleName = (e) => {
    var nameRegex = /[a-zA-Z]/g;
    var nameRegexex = new RegExp(/[^A-Z -]/gi);
    if (nameRegex.test(e.target.value)) {
      setNameErr("");
      if (e.target.value.length === 0) {
        setNameErr("Please enter correct name.");
      }
    } else {
      setNameErr("Please enter correct name.");
    }
    if (nameRegexex.test(e.target.value)) {
      setNameErr("Please enter correct name.");
    }

    const name = e.target.value;
    if (name.length === 0) {
      setNameErr("");
    }
    setName(name);
  };

  const handleEmail = (e) => {
    if (name.trim().length === 0) {
      setNameErr("Name is required field");
    }
    var emailPattern = new RegExp(
      /^\w+([\.-com]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
    );
    if (!emailPattern.test(e.target.value)) {
      setEmailErr("Please enter correct email.");
    } else {
      setEmailErr("");
    }
    const email = e.target.value;
    if (email.length === 0) {
      setEmailErr("");
    }
    setEmail(email);
  };

  const validateMobile = (e) => {
    setNumVerifiedErr("");
    // var pattern = /^(\+\d{1,3}[- ]?)?\d{10}$/;
    var pattern = /^[6-9]\d{9}$/;
    const val = e.target.value;
    if (!pattern.test(val)) {
      setNumberError("Enter only 10-digit mobile number");
    } else {
      setNumber(e.target.value);
      setMobileNo(e.target.value);
      setNumberError("");
    }
    if (val.length === 0) {
      setNumberError("");
      setNumVerifiedErr("");
    }
    setNumber(e.target.value);
    setMobileNo(e.target.value);
  };

  const sendOtp = async (e) => {
    setLoad(true);
    setMobileId(false);
    setLink("");
    // if (sourceName !== null && sourceName !== "")
    // if (sourceName) {
    setOtpErr("");
    setNumVerifiedErr("");
    setMinute(15);
    setSecond(0);
    localStorage.setItem("Name", name);
    localStorage.setItem("Email", email);
    e.preventDefault();
    //Get OTP
    await axios
      .post(`/OTPAutentication/${number}`, {
        name: name,
        email: email,
        formId: formId,
        walkInType: walkInType,
      })
      .then((res) => {
        setStatus(true);
        setCountDown(true);
        setResendStatus(false);
        setRequestCount(res.data.requestCount);
        setLoad(false);
      })
      .catch((err) => {
        setNumVerifiedErr(err.response.data.error);
        setLink(err.response.data.link || "");
        setLoad(false);
      });
    // } else {
    //   localStorage.setItem("Name", name);
    //   localStorage.setItem("Email", email);
    //   e.preventDefault();
    //   //Get OTP
    //   await axios
    //     .post(`/OTPAutentication/${number}`, {
    //       name: name,
    //       email: email,
    //       formId: formId,
    //     })
    //     .then((res) => {
    //       setRequestCount(res.data.requestCount);
    //       setLoad(false);
    //     })
    //     .catch((err) => {
    //       setNumVerifiedErr(err.response.data.error);
    //       setLoad(false);
    //     });
    //   setFormStatus(true);
    // }
    //
  };

  // validateOtp on mobile Number
  const handleOtp = (e) => {
    setOtpErr("");
    var reg = new RegExp("^[0-9]*$");
    if (!reg.test(e.target.value)) {
      setOtpErr("Please enter valid OTP");
    } else if (e.target.value.length > 6) {
      setOtpErr("Please enter valid OTP");
    } else {
      setOtpErr("");
    }
    setOtp(e.target.value);
  };

  const validateOtp = async (e) => {
    e.preventDefault();
    let otpStatus = "";

    try {
      const verifyOtp = await api.post(`/OTPAutentication`, {
        mobileNo: number,
        OTP: otp,
        formId: formId,
      });
      if (verifyOtp.data) {
        setOtpErr("");
      }
      const verifyMobile = await api.get(
        `/OTPAutentication/isMobileNoVerified/${number}/form/${formId}`
      );
      if (verifyMobile.data) {
        otpStatus = verifyMobile.data.OTPStatus;
        setOtpErr("");
      }
      if (otpStatus === "User Authorized" && referalCode && client) {
        window.location.replace(
          `/forms/${formId}?formname=${formName}&mobileno=${number}&source=${sourceName}&client=${client}&refcode=${referalCode}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}&utm_term=${utm_term}`
        );
      } else if (
        otpStatus === "User Authorized" &&
        consultancyName !== null &&
        consultancyName !== "" &&
        consultancyName !== undefined
      ) {
        window.location.replace(
          `/forms/${formId}?formname=${formName}&mobileno=${number}&source=${sourceName}&consultant_name=${consultancyName}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}&utm_term=${utm_term}`
        );
      } else if (
        otpStatus === "User Authorized" &&
        walkInType !== null &&
        walkInType !== "" &&
        walkInType !== undefined
      ) {
        window.location.replace(
          `/forms/${formId}?formname=${formName}&mobileno=${number}&source=${sourceName}&walkInType=Direct&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}&utm_term=${utm_term}`
        );
      } else if (otpStatus === "User Authorized") {
        window.location.replace(
          `/forms/${formId}?formname=${formName}&mobileno=${number}&source=${sourceName}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}&utm_term=${utm_term}`
        );
      } else {
        setOtpErr("Invalid OTP");
      }
      localStorage.removeItem("encryptedNum");
      localStorage.removeItem("minutes");
      localStorage.removeItem("seconds");
    } catch (err) {
      console.log(err);
      otpStatus = err.response.data.OTPStatus;
    }
    // var encryptedNum = btoa(num);
    const encryptedNum = btoa(mobileNo);
    // console.log("referral code", referalCode)
  };

  //Timer for otp functionality
  const [second, setSecond] = useState(localStorage.getItem("seconds") || 0);
  const [minute, setMinute] = useState(localStorage.getItem("minutes") || 1);

  useEffect(() => {
    const timer = setInterval(() => {
      countDown && setSecond(second - 1);
      localStorage.setItem("seconds", second);
      if (second === 0) {
        setMinute(minute - 1);
        setSecond(59);
        if (minute === 0) {
          setMinute(15);
          setSecond(0);
          setResendStatus(true);
          setCountDown(false);
        }
        localStorage.setItem("minutes", minute);
      }
    }, 1000);
    return () => clearInterval(timer);
  }, [second, status]);

  function handleBack() {
    setMobileId(true);
    setStatus(false);
    setResendStatus(false);
    setMinute(15);
    setSecond(0);
    //elem.style.color = "red";
  }

  useEffect(() => {
    setMinute(15);
    setSecond(0);
    // var encryptedNum = btoa(num);
    const encryptedNum = btoa(mobileNo);
    // setTimeout(() => {
    //   if (
    //     numVerifiedErr === "Great! Since you're already a registered user, we will redirect you to the next page to complete your details." &&
    //     referalCode !== null &&
    //     referalCode !== "" &&
    //     referalCode !== undefined &&
    //     client !== null &&
    //     client !== "" &&
    //     client !== undefined
    //   ) {
    //     setFormStatus(false);
    //     console.log("111111111111111111111111111")
    //     window.location.replace(
    //       `/forms/${formId}?formname=${formName}&mobileno=${number}&source=${sourceName}&client=${client}&refcode=${referalCode}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}&utm_term=${utm_term}`
    //     );
    //     localStorage.removeItem("encryptedNum");
    //     localStorage.removeItem("minutes");
    //     localStorage.removeItem("seconds");
    //   } else if (
    //     numVerifiedErr === "Great! Since you're already a registered user, we will redirect you to the next page to complete your details." &&
    //     consultancyName !== null &&
    //     consultancyName !== "" &&
    //     consultancyName !== undefined
    //   ) {
    //     setFormStatus(false);
    //     console.log("2222222222222222222222222222222222222");
    //     window.location.replace(
    //       `/forms/${formId}?formname=${formName}&mobileno=${number}&source=${sourceName}&consultant_name=${consultancyName}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}&utm_term=${utm_term}`
    //     );
    //     localStorage.removeItem("encryptedNum");
    //     localStorage.removeItem("minutes");
    //     localStorage.removeItem("seconds");
    //   } else if (
    //     numVerifiedErr === "Great! Since you're already a registered user, we will redirect you to the next page to complete your details."
    //   ) {
    //     setFormStatus(false);
    //     console.log("sadddddddddddddddddddddddddddddddddddddddddddddd");
    //     window.location.replace(
    //       `/forms/${formId}?formname=${formName}&mobileno=${number}&source=${sourceName}&client=${client}&refcode=${referalCode}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}&utm_term=${utm_term}`
    //     );
    //     //  window.location.replace(
    //     //  `/forms/${formId}?formname=${formName}&mobileno=${number}&source=${sourceName}&&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}&utm_term=${utm_term}`
    //     //  );
    //     localStorage.removeItem("encryptedNum");
    //     localStorage.removeItem("minutes");
    //     localStorage.removeItem("seconds");
    //   }
    // }, 1000);
    setTimeout(() => {
      if (
        numVerifiedErr ===
          "Great! Since you're already a registered user, we will redirect you to the next page to complete your details." &&
        referalCode !== null &&
        referalCode !== "" &&
        referalCode !== undefined &&
        client !== null &&
        client !== "" &&
        client !== undefined
      ) {
        setFormStatus(false);
        window.location.replace(
          `/forms/${formId}?formname=${formName}&mobileno=${number}&source=${sourceName}&client=${client}&refcode=${referalCode}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}&utm_term=${utm_term}`
        );
      } else if (
        numVerifiedErr ===
          "Great! Since you're already a registered user, we will redirect you to the next page to complete your details." &&
        consultancyName !== null &&
        consultancyName !== "" &&
        consultancyName !== undefined
      ) {
        setFormStatus(false);
        window.location.replace(
          `/forms/${formId}?formname=${formName}&mobileno=${number}&source=${sourceName}&consultant_name=${consultancyName}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}&utm_term=${utm_term}`
        );
      } else if (
        numVerifiedErr ===
          "Great! Since you're already a registered user, we will redirect you to the next page to complete your details." &&
        walkInType !== null &&
        walkInType !== "" &&
        walkInType !== undefined
      ) {
        setFormStatus(false);
        window.location.replace(
          `/forms/${formId}?formname=${formName}&mobileno=${number}&source=${sourceName}&walkInType=Direct&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}&utm_term=${utm_term}`
        );
      } else if (
        numVerifiedErr ===
        "Great! Since you're already a registered user, we will redirect you to the next page to complete your details."
      ) {
        setFormStatus(false);
        window.location.replace(
          `/forms/${formId}?formname=${formName}&mobileno=${number}&source=${sourceName}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}&utm_term=${utm_term}`
        );
      }
      localStorage.removeItem("encryptedNum");
      localStorage.removeItem("minutes");
      localStorage.removeItem("seconds");
    }, 1000);

    if (
      numVerifiedErr ===
      "Great! Since you're already a registered user, If you have any questions or need assistance, please feel free to chat with our chatbot for more information."
    ) {
      setFormStatus(false);
    } else if (
      numVerifiedErr ===
      "The maximum allowed limit is 3, which has been reached. Please try again in 24 hours."
    ) {
      setFormStatus(false);
    }

    if (mobileId === true) {
      document.getElementById("myText").focus();
    }

    if (
      (sourceName === null || sourceName === "") &&
      formStatus &&
      numVerifiedErr === "" &&
      numberError === ""
    ) {
      window.location.replace(
        `/forms/${formId}?formname=${formName}&mobileno=${number}&source=${sourceName}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}&utm_term=${utm_term}`
      );
    }
  }, [numVerifiedErr, mobileId, formStatus]);

  const resendOTP = async () => {
    setLoad(true);
    setCountDown(true);
    setMinute(15);
    setSecond(0);
    localStorage.setItem("Name", name);
    localStorage.setItem("Email", email);
    //e.preventDefault()
    //Get OTP
    await axios
      .post(`/OTPAutentication/${number}`, {
        name: name,
        email: email,
      })
      .then((res) => {
        setStatus(true);

        setResendStatus(false);
        setRequestCount(res.data.requestCount);
        setLoad(false);
      })
      .catch((err) => {
        // setCountDown(false);
        setNumVerifiedErr(err.response.data.error);
        setLoad(false);
      });
  };

  useEffect(() => {
    if (
      status === false &&
      nameErr === "" &&
      emailErr === "" &&
      // number.length === 10 &&
      numberError === ""
    ) {
      setOtpCode(false);
    } else {
      setOtpCode(true);
    }
  }, [nameErr, emailErr, numberError]);

  return (
    <Candidate>
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}

      {formName === "" || formName === null ? (
        <div className="col-md-6">
          <h1>Page not found</h1>
        </div>
      ) : (
        <div className="row justify-content-center hy-100">
          <div className="col-md-5">
            <div className="mt-4 p-3 bg-white rounded">
              <h1
                className="candidate-form-title text-center"
                style={{ fontSize: "1.5rem" }}
              >
                {" "}
                {formName}
              </h1>
              <p className="candidate-form-description"></p>
              <hr />

              <form onSubmit={sendOtp}>
                {status === false && (
                  <div>
                    <div className="form-group form-builder-element mb-3">
                      <label>Name*</label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Enter Name..."
                        value={name}
                        onChange={handleName}
                        required
                      />
                      {status === false && (
                        <span style={{ color: "red" }}>{nameErr}</span>
                      )}
                    </div>
                    <div className="form-group form-builder-element mb-3">
                      <label>Email*</label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Enter Email..."
                        value={email}
                        onChange={handleEmail}
                        disabled={
                          mobileNum && emailId && referalCode ? true : false
                        }
                        required
                      />
                      {status === false && (
                        <span style={{ color: "red" }}>{emailErr}</span>
                      )}
                    </div>

                    <div className="form-group form-builder-element mb-3">
                      <label>Mobile Number*</label>
                      <input
                        id="myText"
                        className="form-control"
                        type="text"
                        placeholder="Enter mobile number"
                        value={number}
                        disabled={
                          mobileNum && emailId && referalCode ? true : false
                        }
                        onChange={validateMobile}
                      />
                      {numVerifiedErr !== "" && (
                        <span style={{ color: "red" }}>{numVerifiedErr}</span>
                      )}
                      <br />
                      {status === false && (
                        <span style={{ color: "red" }}>{numberError}</span>
                      )}
                    </div>
                  </div>
                )}
                {status === false && !link && (
                  <button
                    disabled={otpCode}
                    type="submit"
                    className="btn btn-primary border-0 my-3"
                  >
                    SEND OTP
                  </button>
                )}
              </form>
              {link && (
                <button
                  onClick={() => {
                    window.location.replace(link.replace(/^"|"$/g, ""));
                  }}
                  className="btn btn-primary border-0 my-3"
                >
                  Click here
                </button>
              )}
              {/* <div className="mt-5 text-center" style={{ width: "100%" }}>
 <span style={{ fontSize: "25px" }}>Timer </span>{" "}
 <span className="timer" style={{ fontSize: "25px" }}>
 {minute}:{second < 10 ? `0${second}` : second}
 </span>
 </div> */}

              <form onSubmit={validateOtp}>
                {status && (
                  <div className="form-group form-builder-element mb-3">
                    <label>Enter OTP code sent to your number: {number}</label>
                    {/* (Change) */}
                    <button
                      style={{
                        color: "blue",
                        background: "transparent",
                        marginLeft: "6px",
                      }}
                      onClick={handleBack}
                    >
                      Change
                    </button>

                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter OTP"
                      onChange={handleOtp}
                    />
                    {numVerifiedErr !== "" && (
                      <span style={{ color: "red" }}>{numVerifiedErr}</span>
                    )}
                    <br />
                    {otpErr !== "" && (
                      <span style={{ color: "red" }}>{otpErr}</span>
                    )}
                    {!resendStatus && (
                      <div className="otpCaption">
                        <span className="timer">
                          Left: {minute}:{second < 10 ? `0${second}` : second}
                        </span>
                      </div>
                    )}
                  </div>
                )}
                {!resendStatus &&
                  status &&
                  otp !== "" &&
                  otpErr === "" &&
                  otp.length === 6 && (
                    <button
                      type="submit"
                      className="btn btn-primary border-0 my-3"
                    >
                      Submit
                    </button>
                  )}
              </form>
              {resendStatus && status && otpErr === "" && (
                <button
                  className="btn btn-primary border-0 my-3"
                  onClick={resendOTP}
                >
                  Resend
                </button>
              )}
            </div>
          </div>

          <div></div>
        </div>
      )}
    </Candidate>
  );
}

export default ValidateMobile;
